import angular from 'angular';
import {OptionMenuComponent} from './option-menu.component';

export default angular.module('slViz.optionMenuModule', [])
    .component('optionMenu', OptionMenuComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/components/option-menu/index.js